import request from '../../utils/request'
import server from './config'
export default {
  getList:(data)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/prescription/1/drugInfo`,
      method: 'post',
      data,
    })
  },
  //获取指标详情
  getLatestRecord:(params)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/patient/member/indicator/1/getLatestRecord`,
      method: 'get',
      params,
    })
  },
  getRecordList:(data)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/patient/member/indicator/1/getList`,
      method: 'post',
      data,
    })
  },
  getRecordPage:(data)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/patient/member/indicator/1/getPageListGroupByType`,
      method: 'post',
      data,
    })
  },
  getRecordPage2:(data)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/patient/member/indicator/1/getPageListGroupByType2`,
      method: 'post',
      data,
    })
  },
  //新增
  saveRecordPage:(data)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/patient/member/indicator/{version}/saveOrUpdate`,
      method: 'post',
      data,
    })
  },
  //删除
  deleteRecord:(params)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/patient/member/indicator/1/delete`,
      method: 'get',
      params,
    })
  },

}


// WEBPACK FOOTER //
// ./src/api/modules/indicator.js